// this file is generated by update_shopify_store_data.py at 2026-09-29 21:15:59.486538
var courses = [
    {
        "course_id": "B7900F51-870E-F111-99A9-005056A76043",
        "course_version": 3,
        "name": "The Orsini Way - Mastering Medical Error Disclosure",
        "course_type": 1,
        "author_information": "Anthony Orsini, D.O., FAAP",
        "description": "This comprehensive course equips physicians and healthcare professionals with the critical skills required to conduct medical error disclosure conversations in a manner that maintains trust, demonstrates accountability, and prioritizes patient-centered care.\r\n\r\nThe Orsini Way method moves beyond scripted responses to develop participants\u2019 ability to apply structured verbal and non-verbal communication strategies that foster empathy, enhance understanding, and convey information with clarity and intention.\r\n\r\nThrough evidence-based frameworks and immersive case studies, participants gain practical tools to navigate disclosure conversations with professionalism, transparency, and compassion, while strengthening organizational consistency and risk awareness.",
        "learning_objectives_html": "<strong>Upon completion of this activity, participants will be able to:<br />\r\n</strong>\r\n<br />\r\n<ul>\r\n    <li><strong>Analyze </strong>how communication breakdowns contribute to malpractice exposure and patient distrust.\r\n    </li>\r\n    <li><strong>Identify </strong>the essential components of transparent, ethical, and patient-centered medical error disclosure conversations.\r\n    </li>\r\n    <li><strong>Apply </strong>structured, relationship-centered verbal and non-verbal communication techniques including active listening, empathy, and clear language to conduct effective disclosure conversations with clarity and transparency.\r\n    </li>\r\n    <li><strong>Evaluate</strong> the impact of compassionate and timely disclosure on patient trust, provider well-being, and organizational safety culture.\r\n    </li>\r\n</ul>",
        "course_outline_html": "",
        "credit_info": "-",
        "categories": [
            {
                "course_category_id": "DC33B687-264F-DB11-9011-000423ACEF71",
                "course_category_name": "Leadership Development",
                "is_system_course_category": null
            },
            {
                "course_category_id": "D06135AD-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Physician (MD/DO)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "37A67743-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Patient Interactions",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B30546ED-031F-F111-99B4-005056A77B46",
                "course_category_name": "The Orsini Way - Mastering Medical Error Disclosure",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C98E2D7E-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Anesthetist",
                "is_system_course_category": null
            },
            {
                "course_category_id": "48F6A169-F51E-F111-99B4-005056A77B46",
                "course_category_name": "Orsini Way, The",
                "is_system_course_category": null
            },
            {
                "course_category_id": "2D0703A4-DFA9-EB11-80E1-005056B17C18",
                "course_category_name": "Patient Safety",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0D08A045-CD96-EF11-998E-005056A7DAD4",
                "course_category_name": "CME Courses - a la carte (Publish with CPP)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "1F4B1A8B-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse Midwife",
                "is_system_course_category": null
            },
            {
                "course_category_id": "971E14AF-67DA-E511-9165-005056B141CC",
                "course_category_name": "Ethical Practice",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0D029A6E-0C11-E811-96E0-005056B12696",
                "course_category_name": "Course",
                "is_system_course_category": null
            },
            {
                "course_category_id": "C3BEF86B-35D4-E511-93E1-005056B12CFE",
                "course_category_name": "Quality Care",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6D3D593B-79AC-F111-99B4-005056A76D1A",
                "course_category_name": "Parent: The Orsini Way",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EB0C13C7-0116-EA11-8041-005056B15B8C",
                "course_category_name": "All Settings",
                "is_system_course_category": null
            },
            {
                "course_category_id": "6429BC8C-6F00-E711-9B94-005056B141CC",
                "course_category_name": "Workforce Culture",
                "is_system_course_category": null
            },
            {
                "course_category_id": "EF2C23AC-E357-DB11-A8F9-000423ACEF71",
                "course_category_name": "Effective Communication",
                "is_system_course_category": null
            },
            {
                "course_category_id": "3B66D963-08DB-E511-AA9E-005056B17E48",
                "course_category_name": "Quality Assurance and Performance Improvement",
                "is_system_course_category": null
            },
            {
                "course_category_id": "0FFAC624-CD96-EF11-998E-005056A7DAD4",
                "course_category_name": "NurseGrid Learn - a la carte ONLY (Publish with CPP)",
                "is_system_course_category": null
            },
            {
                "course_category_id": "7C6F7677-8F9E-E511-9627-005056B1456A",
                "course_category_name": "Nurse Practitioner",
                "is_system_course_category": null
            },
            {
                "course_category_id": "B30B4D62-168A-E511-A452-005056B12710",
                "course_category_name": "Patient Satisfaction",
                "is_system_course_category": null
            },
            {
                "course_category_id": "43D048A0-1EC9-E511-8771-005056B104B1",
                "course_category_name": "Nurse",
                "is_system_course_category": null
            },
            {
                "course_category_id": "4F027BAC-08C9-E511-8771-005056B104B1",
                "course_category_name": "Clinical Nurse Specialist",
                "is_system_course_category": null
            }
        ],
        "ce_accreditation": {
            "accrediting_body_name": null,
            "accreditation_statement": null,
            "course_level_accreditation_statement": null,
            "credit_display_name": null,
            "credit_units": null,
            "credit_unit_display_name": null
        },
        "sub_courses": []
    }
];